import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { PatientData } from '../../interfaces/patient-data';
import { Logger } from 'ionic-logging-service';
import { CheckDatePipe } from 'src/app/shared/pipes/check-date.pipe';
/*
  Generated class for the PatientDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PatientDataProvider {

  private logger: Logger;

  patientData: Array<PatientData> = [];
  showtransmitterId = '';
  activePatientData: PatientData = new PatientData();
  activePatientName = '';
  editPatientData: PatientData = new PatientData();

  constructor(public api: Api) {
   
  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.PatientDataProvider');
  }

  resetActivePatientData() {
    this.activePatientData = new PatientData();
  }

  getAll() {
    return this.api.get('patients');
  }

  getErrorIntervallTest() {
    return this.api.get('patientErrorTest');
  }

  getByRelationAppId(data: any){
    return this.api.get('patientsWithRelations', {id: data.id});
  }

  /**
   * suchen nach Angehörigen in Patienendata.contacts, die ein AppId besitzen
   * wird beim Anlegen einen neuen Angehörigen verwendet
   * um wiederholte Profile in User Table auszuschliessen
   * data:any enthält firstname:string, lastname:string, zip:number, ...
   */
  getRelationByEmail(data: any){
    console.log(data);
    // return new Promise((resolve) => resolve(this.api.get('relationByData', data)));
    return this.api.get('relationByEmail', data);
  }

  get(patientDocId) {
    return this.api.get('patientbyid', {id: patientDocId});
  }

  exportActivitys(from, to) {
    return this.api.get('exportActivitys', {from, to});
  }

  query(params?: any) {
    this.getLogger().info('query', {message: params.transmitterId});
    return this.api.get('patient', {transmitterId: params.transmitterId});
  }

  add(item: PatientData) {
    return new Promise((resolve) => {
      this.getLogger().info('add', {message: 'Patient angelegt'});
      item.addressData.birthDate = new CheckDatePipe().transform(item.addressData.birthDate, 'toDB');
      this.api.post('patient', {body: item}).subscribe((resp: any) => {
        item._id = resp.data.data.data.id;
        item._rev = resp.data.data.data.rev;
        this.patientData.push(item);
        resolve(item);
      });
    });
  }

  update(item: PatientData) {
    this.getLogger().info('update', {message: 'Patient Daten Update'});
    item.addressData.birthDate = new CheckDatePipe().transform(item.addressData.birthDate, 'toDB');
    return this.api.put('patient', {body: item});
  }

  delete(item: PatientData) {

    return new Promise((resolve, reject) => {
      this.api.delete('patient', {_id: item._id, _rev: item._rev}).subscribe({next:(res) => {
        this.getLogger().info('delete', {message: 'Patient gelöscht'});
        this.patientData.splice(this.patientData.indexOf(item), 1);
        resolve(res);
      }, error:(err) => {
        reject(err);
      }});
    });
  }

  async getContacts(callerId= null): Promise<Array<any>> {
     const res: any = await new Promise((resolve) => {
      if (this.activePatientData._id) {
        this.get(this.activePatientData._id).subscribe((data: any) => {
          resolve(data);
        });
      } else {
        this.query({transmitterId: callerId}).subscribe((data: any) => {
          if (data.data.data.data.docs.length) {
            data.data.data.data = data.data.data.data.docs[0];
          } else {
            data.data.data.data = new PatientData();
          }

          resolve(data);
        });
      }
    });

     this.activePatientData = res.data.data.data;


     this.activePatientData.addressData.code = this.activePatientData.transmitterId;
     const selfId = localStorage.getItem('prom');
     const contects: Array<any> = [this.activePatientData.addressData];

     this.activePatientData.contacts.forEach((contact) => {
      if (contact.appId && contact.appId !== selfId) {
        (contact as any).code = contact.appId;
        contects.push(contact);
      }
    });

     return Promise.resolve(contects);
  }

}
